import { useEffect, useState } from 'react';
import { useLang } from '../i18n/LanguageContext';
import { storefront } from '../lib/supabase';
import { pickLang } from '../lib/format';

export default function Story() {
  const { lang, t } = useLang();
  const [story, setStory] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    storefront.content().then(({ data }) => {
      setStory((data || []).find((x) => x.key === 'story'));
      setLoading(false);
    });
  }, []);

  if (loading) return <div className="loading">{t('misc.loading')}</div>;

  return (
    <div className="container section" style={{ maxWidth: 760 }}>
      <div style={{ textAlign: 'center', fontSize: 44 }}>🌊</div>
      <h1 style={{ textAlign: 'center' }}>{story ? pickLang(story, 'title', lang) : 'Life in Nha Trang'}</h1>
      <div className="card" style={{ padding: 28, whiteSpace: 'pre-line', fontSize: 17, lineHeight: 1.7 }}>
        {story ? pickLang(story, 'body', lang) : t('misc.error')}
      </div>
    </div>
  );
}
